import { render, staticRenderFns } from "./SmartPOSTBannersView.vue?vue&type=template&id=175a9132&scoped=true"
import script from "./SmartPOSTBannersView.vue?vue&type=script&lang=ts"
export * from "./SmartPOSTBannersView.vue?vue&type=script&lang=ts"
import style0 from "./SmartPOSTBannersView.vue?vue&type=style&index=0&id=175a9132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a9132",
  null
  
)

export default component.exports